import { render, staticRenderFns } from "./TPrintDropdownItem.vue?vue&type=template&id=51e0c3a4&"
import script from "./TPrintDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./TPrintDropdownItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports